import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";
import rehypeExternalLinks from "rehype-external-links";
import {
	Box,
	Link,
	Text,
	UnorderedList,
	OrderedList,
	ListItem,
	Divider,
} from "@chakra-ui/react";

export function MarkdownPreset({ content }: { content: string }) {
	return (
		<Box
			className="md-preset"
			fontSize="14px"
			color="#1A202C"
			lineHeight="1.6"
			sx={{
				"h1,h2,h3": {
					fontWeight: 700,
					lineHeight: "1.2",
					marginTop: "0.75rem",
					marginBottom: "0.5rem",
				},
				h1: { fontSize: "18px" },
				h2: { fontSize: "16px" },
				h3: { fontSize: "14px" },
				p: { marginBottom: "0.5rem" },
				a: { color: "#0087EE", fontWeight: 600 },
				code: {
					background: "#0000000A",
					padding: "0.1rem 0.25rem",
					borderRadius: "0.25rem",
				},
				pre: {
					background: "#0000000A",
					padding: "0.75rem",
					borderRadius: "0.5rem",
					overflow: "auto",
				},
				hr: { margin: "0.75rem 0" },
			}}
		>
			<ReactMarkdown
				remarkPlugins={[remarkGfm]}
				rehypePlugins={[
					rehypeSanitize,
					[
						rehypeExternalLinks,
						{ target: "_blank", rel: ["noopener", "noreferrer"] },
					],
				]}
				components={{
					p: ({ children }) => <Text mb="2">{children}</Text>,
					a: ({ href, children }) => {
						const isTelOrMail =
							href?.startsWith("tel:") || href?.startsWith("mailto:");

						return (
							<Link
								href={href as string}
								color="#0087EE"
								fontWeight="600"
								target={isTelOrMail ? undefined : "_blank"}
								rel={isTelOrMail ? undefined : "noopener noreferrer"}
								// textDecoration={isTelOrMail ? "none" : "underline"}
							>
								{children}
							</Link>
						);
					},
					ul: ({ children }) => (
						<UnorderedList pl="5" mb="2">
							{children}
						</UnorderedList>
					),
					ol: ({ children }) => (
						<OrderedList pl="5" mb="2">
							{children}
						</OrderedList>
					),
					li: ({ children }) => <ListItem mb="1">{children}</ListItem>,
					hr: () => <Divider my="3" />,
				}}
			>
				{content}
			</ReactMarkdown>
		</Box>
	);
}
